/**
 * @summary - Component that Provides Work Order Reschedule Repository 
 * @autor vengateshwaran k
 * @since 2024-06-21
 */
import ReArrangeLabel from "../../components/commoncomponents/ReArrangeLabel";
import { BemsGraph, FemsGraph, MasterGraph } from "../../utility/apiURLS";
import Axios from '../data-access/genericAxios';


async function getWorkOrderOptions(facilityId) {
      const [responseFems, responseBems] = await Promise.all([
            Axios.get(`${FemsGraph}/GetRescheduleWorkOrderNobyFacilityId/${facilityId}?size=10000`),
            Axios.get(`${BemsGraph}/GetRescheduleWorkOrderNobyFacilityId/${facilityId}?size=10000`)
      ]);
      if ((responseFems?.status !== 'error') && (responseBems?.status !== 'error') &&
          (responseFems?.status >= 200 && responseFems?.status <= 204) && 
          (responseBems?.status >= 200 && responseBems?.status <= 204)) {
            const combinedData = [...responseFems.data, ...responseBems.data];
            const reArrangedData = ReArrangeLabel(combinedData, "workorderno", "label");
            return reArrangedData;
      }
      return { fems: responseFems, bems: responseBems };
}

async function getServiceDetails() {
      const response = await Axios.get(`${MasterGraph}/api/masservicedetails?size=1000`);
      if ((response?.status !== 'error') && (response?.status >= 200 && response?.status <= 204)) {
            const reArrangedData = ReArrangeLabel(response?.data, "servicedesc", "label");
            return reArrangedData;
      }
      return response;
}
async function rescheduleWorkOrder(values,service) {
      const checkFemorBem = service === "FEMS" ? "fem" : "bem"
      const checkGraph = service === "FEMS" ? FemsGraph : BemsGraph
      const response = await Axios.post(`${checkGraph}/api/${checkFemorBem}rescheduledworkorderheaders`, values);
      return response;
}
async function getAllRows(service,workorderId) {
      const checkFemorBem = service === "FEMS" ? "GetsubformFemReScheduleWorkOrder" : "GetsubformBemReScheduleWorkOrder"
      const checkGraph = service === "FEMS" ? FemsGraph : BemsGraph
      const response = await Axios.get(`${checkGraph}/${checkFemorBem}/${workorderId}`);
      return response?.data;
}

async function updateRescheduleWorkOrder(id,values,service) {
      const checkFemorBem = service === "FEMS" ? "fem" : "bem"
      const checkGraph = service === "FEMS" ? FemsGraph : BemsGraph
      const response = await Axios.update(`${checkGraph}/api/${checkFemorBem}rescheduledworkorderheaders/${id}`, values);
      return response;
}

async function updateWorkorderTargetDate(id,values,service) {
      const checkFemorBem = service === "FEMS" ? "UpdateFemppmscheduletrack" : "UpdateBemppmscheduletrack"
      const checkGraph = service === "FEMS" ? FemsGraph : BemsGraph
      const response = await Axios.update(`${checkGraph}/${checkFemorBem}/${id}`, values);
      return response;
}

async function deleteRescheduleWorkOrder(idForDelete,service) {
      const checkFemorBem = service === "FEMS" ? "fem" : "bem"
      const checkGraph = service === "FEMS" ? FemsGraph : BemsGraph
      const response = await Axios.remove(`${checkGraph}/api/${checkFemorBem}rescheduledworkorderheaders/${idForDelete}`);
      if ((response?.status !== 'error') && (response?.status >= 200 && response?.status <= 204)) {
      }
      return response;
}

const workOrderResscheduleRepository = {
      getWorkOrderOptions,
      getServiceDetails,
      rescheduleWorkOrder,
      updateRescheduleWorkOrder,
      deleteRescheduleWorkOrder,
      updateWorkorderTargetDate,
      getAllRows
};


export default workOrderResscheduleRepository;